"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditIcon = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const ThemeProvider_1 = require("../ThemeProvider/ThemeProvider");
const IconContainer_1 = __importDefault(require("./IconContainer"));
const EditIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    const theme = (0, react_1.useContext)(ThemeProvider_1.ThemeContext);
    return (react_1.default.createElement(IconContainer_1.default, Object.assign({ className: (0, classnames_1.default)("gerudo-icon-edit", size, className) }, props), theme === ThemeProvider_1.Theme.Akinox ? (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.0", viewBox: "0 0 20 20", fill: "none", "aria-label": title },
        react_1.default.createElement("title", null, title),
        react_1.default.createElement("path", { d: "M7.14896 17.674L6.47303 18.341H1.68311V13.5471L2.35069 12.8801M7.14896 17.674C6.74308 16.5762 6.10402 15.5792 5.27572 14.7517C4.44742 13.9241 3.44953 13.2856 2.35069 12.8801M7.14896 17.674L15.9277 8.88661M2.35069 12.8801L11.3214 3.90931C13.4552 4.89448 15.1115 6.68417 15.9277 8.88661M15.9277 8.88661L17.8136 7.00241C18.1124 6.69434 18.298 6.29438 18.3405 5.86754C18.3829 5.44069 18.2796 5.01206 18.0473 4.65132C17.3563 3.58029 16.4428 2.67039 15.3686 1.98342C15.009 1.74689 14.579 1.641 14.1506 1.6835C13.7222 1.726 13.3214 1.9143 13.0154 2.21686L11.3047 3.8843C12.3668 4.37322 13.3218 5.06675 14.1152 5.92515C14.9085 6.78355 15.5244 7.78993 15.9277 8.88661Z", stroke: "currentColor", strokeWidth: "1.67", strokeLinecap: "round", strokeLinejoin: "round" }))) : (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.0", viewBox: "0 0 128 128.001", role: "img", "aria-label": title },
        react_1.default.createElement("title", null, title),
        react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", fillRule: "evenodd", d: "M93.12,2.13a7.283,7.283,0,0,1,10.294,0l22.455,22.455a7.286,7.286,0,0,1,0,10.3l-14.5,14.511L78.608,16.638ZM72.061,23.185l32.756,32.761L34.887,125.87A7.277,7.277,0,0,1,29.74,128H7.279A7.278,7.278,0,0,1,0,120.723V98.261a7.28,7.28,0,0,1,2.132-5.147Z", fill: "currentColor", role: "presentation" })))));
};
exports.EditIcon = EditIcon;
EditIcon.defaultProps = {
    title: "Edit",
};
exports.default = EditIcon;
//# sourceMappingURL=Edit.js.map